import styled from "styled-components";

export const ImageStyled = styled.img`
  object-fit: cover;
`;
